import React from "react";

import Dashboard from "../views/dashboardClient/index"
import Faq from "../views/faq/faq";
import Chat from "../views/chat/index";

//icons
import  DashIcon  from "../assets/icons/dashboard.svg"
import  DashboardHover  from "../assets/icons/dashboardHover.svg"
import  ClientIcon  from "../assets/icons/man.svg"
import  ClientHover from "../assets/icons/manHover.svg"
import CardIcon from "../assets/icons/credit-card.svg"
import CardIconHover from "../assets/icons/credit-card-hover.svg";
import PayOrderIcon from "../assets/icons/pay-order.svg";
import PayOrderIconHover from "../assets/icons/pay-orderHover.svg";
import SubscriptionIcon from "../assets/icons/money.svg";
import SubscriptionIconHover from "../assets/icons/moneyHover.svg";
import ConfigurationIcon from "../assets/icons/gear.svg";
import ConfigurationIconHover from "../assets/icons/gearHover.svg";
import PixIcon from "../assets/icons/pixIcon.svg";
import PixIconHover from "../assets/icons/pixIconHover.svg";
import ListIcon from "../assets/icons/plans.svg";
import ListHoverIcon from "../assets/icons/plans-hover.svg";
import EcommerceIcon from "../assets/icons/bag.svg";
import EcommerceIconHover from "../assets/icons/bagHover.svg";


var routes = [
  {
    id: "cm1",
    path: "/dashboard",
    name: "Dashboard",
    icon: DashIcon,
    iconHover:DashboardHover,
    layout: "/admin",
    component: Dashboard,
    redirect: false,
  },

  {
    id: "cm2",
    path: "/client",
    name: "Cliente",
    icon: ClientIcon,
    iconHover:ClientHover,
    layout: "/admin",
    redirect: false,
  },

    {
      id: "cm3",
      path: "/card",
      name: "Cartão",
      icon: CardIcon,
      iconHover: CardIconHover,
      layout: "/admin",
      redirect: true,
    },
    
    
    {
      id: "cm4",
      path: "/pay-order",
      name: "Boleto",
      icon: PayOrderIcon,
      iconHover: PayOrderIconHover,
      layout: "/admin",
      redirect: false,
    },
    
    {
      id: "cm5",
      path: "/subscription",
      name: "Assinatura",
      icon: SubscriptionIcon,
      iconHover: SubscriptionIconHover,
      layout: "/admin",
      redirect: false,
    },

    {
      id: "",
      path: "/ecommerce",
      name: "Ecommerce",
      icon: EcommerceIcon,
      iconHover: EcommerceIconHover,
      layout: "/admin",
      redirect: false,
    },

    {
      id: "cm7",
      path: "/pix",
      name: "Pix",
      icon: PixIcon,
      iconHover: PixIconHover,
      layout: "/admin",
      redirect: false,
    },
    
    {
      id: "cm8",
      path: "/campaigns",
      name: "Campanhas",
      icon: ListIcon,
      iconHover: ListHoverIcon,
      layout: "/admin",
      redirect: false,
    },

  {
    path: "/faq",
    name: "FAQ",
    layout: "/doubts",
    component: Faq,
    redirect: false,
  },

  {
    path: "/chat",
    name: "FAQ",
    layout: "/doubts",
    component: Chat,
    redirect: false,
  },

  {
    id: "cm6",
    path: "/configuration",
    name: "Configuração",
    icon: ConfigurationIcon,
    iconHover: ConfigurationIconHover,
    layout: "/admin",
    redirect: false,
  },
];

export default routes;
